import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_ACCEPTANCE_SERVICE: string = "OrderAcceptanceServiceChannel";

export interface IOrderAcceptanceService {
  requestAcceptance(
    ids: Array<string>,
    comment: string,
    acceptanceAction: CubiqTS.AcceptanceAction,
    acceptanceType: CubiqTS.AcceptanceType,
    targetGroupId?: string,
    callOrderRateSide?: CubiqTS.RateSideType,
    orderType?: CubiqTS.OrderType,
    benchmarkOrderType?: CubiqTS.BenchmarkOrderType,
  ): Promise<any[]>;
}
